var map = {
	"./ID.webp": 787,
	"./INDO.webp": 788,
	"./MY.webp": 789,
	"./TH.webp": 790,
	"./VN.webp": 791,
	"./malaysia.webp": 792
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 396;
module.exports = webpackAsyncContext;